import v4 from 'uuid/v4'
import * as graph from '../api/graph'
import { updateView } from './views'

export const updateGraphUnite = (value) => (dispatch) => {
  dispatch({
    type: 'UPDATE_GRAPH_UNITE',
    value,
  })
  dispatch(updateView())
}

export const fetchDepenses = (payload) => async (dispatch) => {
  const uuid = v4()

  dispatch({
    type: 'FETCH_DEPENSES_REQUEST',
    uuid,
  })

  try {
    const response = await graph.fetchDepenses(uuid, payload)
    if (response.headers.get('X-REQUEST-ID') !== uuid) return

    const data = await response.json()

    dispatch({
      type: 'FETCH_DEPENSES_SUCCESS',
      data,
    })
  } catch (error) {
    dispatch({
      type: 'FETCH_DEPENSES_FAILURE',
      message: error.message || 'Something went wrong.',
    })
  }
}
